import { useEffect, useRef, useState } from 'react';

import { CollapseProps, CollapseReturnedProps } from './types';

export const useAnimatedCollapse = ({ isOpen = true }: CollapseProps): CollapseReturnedProps => {
  const [initStep, setInitStep] = useState<boolean>(isOpen);
  const [contentHeight, setContentHeight] = useState<number>(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && initStep) {
      setContentHeight(ref.current?.scrollHeight);
      setInitStep(false);
    }
  }, [ref, isOpen]);

  const collapseHandle = () => {
    if (ref.current) {
      setContentHeight((prev) => {
        return prev ? 0 : ref.current?.scrollHeight || 0;
      });
    }
  };

  // Recommended use CollapseAnimationStyles style helper for default collapse styles
  return {
    contentHeight,
    collapseHandle,
    ref
  };
};
